import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    cosmostationWallet: 'Cosmostation Wallet',
  },
};
